function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "telegram"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 5",
  width: 20,
  height: 20,
  fill: "#C4C4C4",
  fillOpacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.44586 8.79509C1.43753 9.20009 1.44336 9.76259 2.26086 10.0134L6.05419 11.1968L14.8309 5.65926C15.2459 5.40676 15.625 5.54259 15.3134 5.81926L8.20253 12.2368H8.20086L8.20253 12.2376L7.94086 16.1476C8.32419 16.1476 8.49336 15.9718 8.70836 15.7643L10.5509 13.9726L14.3834 16.8034C15.09 17.1926 15.5975 16.9926 15.7734 16.1493L18.2892 4.29259C18.5467 3.26009 17.895 2.79259 17.2209 3.09759V3.09759L2.44586 8.79509Z",
  fill: "white"
}));

var SvgTelegramLogo = function SvgTelegramLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegramLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram_logo.4b58af26.svg";
export { ForwardRef as ReactComponent };